/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/24/logo-twitter': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M13.82 10.51l7.1-8.26h-1.68l-6.17 7.17-4.93-7.17H2.46l7.45 10.84-7.45 8.66h1.68l6.52-7.57 5.2 7.57h5.68l-7.73-11.24zm-2.31 2.68l-.75-1.08-6.01-8.59h2.58l4.85 6.93.76 1.08 6.3 9.01h-2.59l-5.14-7.35z" _fill="#212121"/>'
  }
})
